import { getCrewBaseAtDate } from "@vmosolutions/oc-interfaces";
import { Auth, API } from "aws-amplify";
import { ICrewMember } from "../../reducers/CrewScheduleReducer";
/**
 * returns crew that has been filtered for non active and had the fields
 * operatingBase, isSelected, isExpanded, lastModified added
 */
export const getCrew = async (): Promise<ICrewMember[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const crew: ICrewMember[] = await API.get("skytrains", "/users/crew", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });
  // return crew.filter((val: ICrewMember) => val.crewInfo.isActive);
  return (
    crew
      // .filter((c) => !!c.active)
      .map((c) => ({
        ...c,
        operatingBase: getCrewBaseAtDate(c.crewInfo.bases, new Date()?.valueOf()),
        isSelected: false,
        isExpanded: false,
        lastModified: Date.now(),
      }))
  );
};
